import { Typography } from "@material-ui/core";
import { get } from "lodash";
import * as React from "react";
import { useParams } from "react-router-dom";
import BaseLayout from "../../components/BaseLayout";
import EventComponent from "../../components/Event";
import EventFooter from "../../components/EventFooter";
import EventTimelineComponent from "../../components/EventTimeline";
import Home from "../../features/Home";
import HomePageFilter from "../../features/Home/HomePageFilter";
import { useHubx, useHubXSubscribe } from "../../HubX";
import useConstructor from "../../core/hooks/useConstructor";
import { FETCH_BUSINESS_EVENT_BY_ID } from "../../Fedx";
import BusinessEvent from "../../core/models/BusinessEvent";
import { BUSINESS_EVENT_UPDATED } from "../../Events";
import EventStep from "../../core/models/EventStep";
import ProtectedRender from "../../features/ProtectedRender";
import { APROVACAO, CONFIRMACAO } from "../../core/models/Enum/EventActionStep";
import { PERMISSION_APPROVE_CHARGE, PERMISSION_CONFIRM_CHARGE } from "../../core/models/Permission";

function EventScreen() {
  const RouteParams = useParams();
  const businessEventNumber = get(RouteParams, "businessEvent_id");
  const [businessEvent, setBusinessEvent] = React.useState<BusinessEvent>();
  const [eventSteps, setEventSteps] = React.useState<EventStep[]>();
  const [isAuthorized, setIsAuthorized] = React.useState<boolean>(true);
  const hub = useHubx();

  const unauthorizedStyle = {
    fontFamily: "Linde,Arial,Roboto,-apple-system,sans-serif",
    display: "flex",
    justifyContent: "space-around",
    fontSize: "xx-large",
    color: "#ff1f1f",
  };

  useConstructor(async () => {
    if (businessEvent) return;
    const businessEventResult: BusinessEvent = await hub
      .request(FETCH_BUSINESS_EVENT_BY_ID, businessEventNumber)
      .catch(() => {
        setIsAuthorized(false);
      });
    setBusinessEvent(businessEventResult);
    setEventSteps(businessEventResult?.etapas_registradas);
  });

  const handleBusinessEventUpdated = async () => {
    const businessEventResult = await hub.request(FETCH_BUSINESS_EVENT_BY_ID, businessEventNumber);
    setBusinessEvent(businessEventResult);
    setEventSteps(businessEventResult?.etapas_registradas);
  };

  useHubXSubscribe(BUSINESS_EVENT_UPDATED, handleBusinessEventUpdated);

  const etapaAtual = eventSteps?.reduce((x, y) => (x.etapa_evento > y.etapa_evento ? x : y))
    .etapa_evento;
  return (
    <BaseLayout paddingTop>
      {isAuthorized ? (
        <EventComponent businessEvent_id={businessEventNumber}></EventComponent>
      ) : (
        <div style={unauthorizedStyle}> Usuário não autorizado</div>
      )}
      {isAuthorized && businessEvent && eventSteps ? (
        <EventTimelineComponent
          businessEvent={businessEvent}
          eventSteps={eventSteps}
        ></EventTimelineComponent>
      ) : null}
      {isAuthorized && etapaAtual === APROVACAO ? (
        <ProtectedRender permission={[PERMISSION_APPROVE_CHARGE]}>
          <EventFooter businessEvent_id={businessEventNumber}></EventFooter>
        </ProtectedRender>
      ) : isAuthorized ? (
        <ProtectedRender permission={[PERMISSION_CONFIRM_CHARGE]}>
          <EventFooter businessEvent_id={businessEventNumber}></EventFooter>
        </ProtectedRender>
      ) : null}
    </BaseLayout>
  );
}

export default EventScreen;
